import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { QuestionCardAiMenu } from '../../features/question-card-ai/components/QuestionCardAiMenu';
import { useIsQuestionCardAiTarget } from '../../features/question-card-ai/hooks/useIsQuestionCardAiTarget';
import { useQuestionCardAiMenuItems } from '../../features/question-card-ai/hooks/useQuestionCardAiMenuItems';
import { useQuizList } from '../useQuizList';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { EditableOX } from './OX';
import { useQuizControl } from './QuizControlProvider';
export const OXBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    id,
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    items: aiMenuItems,
    trackMenuOpen
  } = useQuestionCardAiMenuItems({
    quizId: id,
    quizIndex: index,
    place: 'mobile_drawer'
  });
  const isAiTarget = useIsQuestionCardAiTarget(id);
  return <Fragment>
      <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
        {leftSlot}
        <div className="flex flex-row items-center gap-xs">
          <QuestionCardAiMenu />
          <EditTools.QuizDuplicateButton />
          <EditTools.QuizDeleteButton />
          <EditTools.EditToolsDrawer onOpen={trackMenuOpen} tools={[...aiMenuItems.map(item => ({
          icon: item.icon,
          label: item.label,
          onClick: item.onSelect,
          disabled: item.disabled,
          description: item.reason
        })), {
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.duplicate.button')),
          disabled: isAiTarget,
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.delete')),
          disabled: isAiTarget,
          onClick: () => {
            void handleDelete(index);
          }
        }]} />
        </div>
      </div>

      <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
        <EditableOX />
        <EditableHint />
      </div>
    </Fragment>;
});